import { API_REFERENCE } from '../utilities/constant_api';
const $doc = $(document);
let IDLE_TIMEOUT = $('#sessionTime').val();
let idleSecondsCounter = 0;
let overlayClass = 'session-timeout-section';
let extendButton = '.extend-session-btn';
let cancelBtn = '.cancel-session-btn';
let logoutSession = false;
let interval;
let cboxOptions = {
  maxWidthLg: '900px',
  maxHeightLg: '800px',
  maxWidthMd: '600px',
  maxHeightMd: '500px',
  maxWidthSm: 'auto',
  maxHeightSm: 'auto'
};

const sessionTimeout = {
  checkWidth() {
    if (window.innerWidth >= 1368) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  },
  checkHeight() {
    if (window.innerHeight >= 1368) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 1368) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  },
  openSessionPopup() {
    sessionTimeout.timeOutLocationUrl();
    ACC.colorbox.open('', {
      escKey: false,
      overlayClose: false,
      closeButton: false,
      html: $('#sessionTimeoutOverlay').html(),
      onLoad: $('#cboxOverlay').css('position', 'fixed'),
      width: sessionTimeout.checkWidth(),
      height: sessionTimeout.checkHeight(),
      className: overlayClass,
      onComplete: function() {
        clearInterval(interval);
        interval = setInterval(function() {
          var timer = $('.time-counter').html();
          timer = timer.split(':');
          var minutes = timer[0];
          var seconds = timer[1];
          seconds -= 1;
          if (minutes < 0) return;
          else if (seconds < 0 && minutes != 0) {
            minutes -= 1;
            seconds = 59;
          } else if (seconds < 10 && length.seconds != 2)
            seconds = '0' + seconds;

          $('.time-counter').html(minutes + ':' + seconds);
          $('.time-counter-visible').html(minutes + ':' + seconds);

          if (minutes == 0 && seconds == 0) {
            logoutSession = true;
            clearInterval(interval);
          }
        }, 1000);
      }
    });
  },
  resetTimer() {
    idleSecondsCounter = 0;
  },
  CheckIdleTime() {
    idleSecondsCounter++;
    if (
      idleSecondsCounter >= IDLE_TIMEOUT - 120 &&
      !$('.session-timeout-section').is(':visible')
    ) {
      sessionTimeout.openSessionPopup();
    }
  },
  endSession() {
    if (logoutSession == true) {
    }
    window.location.replace(
      `${window.location.origin}${API_REFERENCE.sessionTimeout.logout}`
    );
  },
  timeOutLocationUrl() {
    const signOutLocationUrl =
      ACC.config.encodedContextPath + API_REFERENCE.sessionTimeout.locationURL;
    $.ajax({
      type: 'GET',
      url: signOutLocationUrl + '?lastVisitedPageUrl=' + window.location.href,
      success: function(response) {
        console.log('Success');
      }
    });
  },
  extendSession() {
    if (logoutSession) {
      window.location.replace(
        `${ACC.config.encodedContextPath}${API_REFERENCE.sessionTimeout.defaultLogout}`
      );
    } else {
      let currentUrl = window.location.href;
      window.location.replace(currentUrl);
    }
  },
  init() {
    if ($('#isAuthenticatedSession').val() === 'true') {
      window.setInterval(this.CheckIdleTime, 1000);
    }
    $doc.on('click', this.resetTimer);
    $doc.on('click', extendButton, this.extendSession);
    $(document).on('click', '.cancel-session-btn', this.endSession);
  }
};

// $doc.ready(function() {
sessionTimeout.init();
// });

export default sessionTimeout;
